/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_AnalyzingInputs */

const en_jobs_analyzing = /** @type {(inputs: Jobs_AnalyzingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyzing...`)
};

const de_jobs_analyzing = /** @type {(inputs: Jobs_AnalyzingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyse...`)
};

const fr_jobs_analyzing = /** @type {(inputs: Jobs_AnalyzingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyse en cours...`)
};

const es_jobs_analyzing = /** @type {(inputs: Jobs_AnalyzingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analizando...`)
};

const it_jobs_analyzing = /** @type {(inputs: Jobs_AnalyzingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analisi...`)
};

const nl_jobs_analyzing = /** @type {(inputs: Jobs_AnalyzingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyseren...`)
};

const pl_jobs_analyzing = /** @type {(inputs: Jobs_AnalyzingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analizowanie...`)
};

const fi_jobs_analyzing = /** @type {(inputs: Jobs_AnalyzingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analysoidaan...`)
};

const da_jobs_analyzing = /** @type {(inputs: Jobs_AnalyzingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyserer...`)
};

const sv_jobs_analyzing = /** @type {(inputs: Jobs_AnalyzingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyserar...`)
};

/**
* | output |
* | --- |
* | "Analyzing..." |
*
* @param {Jobs_AnalyzingInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_analyzing = /** @type {((inputs?: Jobs_AnalyzingInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_AnalyzingInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_analyzing(inputs)
	if (locale === "fr") return fr_jobs_analyzing(inputs)
	if (locale === "es") return es_jobs_analyzing(inputs)
	if (locale === "it") return it_jobs_analyzing(inputs)
	if (locale === "nl") return nl_jobs_analyzing(inputs)
	if (locale === "pl") return pl_jobs_analyzing(inputs)
	if (locale === "fi") return fi_jobs_analyzing(inputs)
	if (locale === "da") return da_jobs_analyzing(inputs)
	if (locale === "sv") return sv_jobs_analyzing(inputs)
	return en_jobs_analyzing(inputs)
});